// middleware.ts
import { Middleware } from 'redux';
import { addConversation, deleteConversation, editConversationTitle, setConversations, setSelectedConversation } from '../redux/features/conversations/conversationsSlice';
import { Constants } from '../Constants';
import { updateTokenUsage } from '../redux/features/app/appSlice';


const replaceRecursive = (str: string, pattern: RegExp, replacement: string): string => {
  while (pattern.test(str)) {
    str = str.replace(pattern, replacement);
  }
  return str;
};


const localStorageMiddleware: Middleware = store => next => (action: any) => {
  const result = next(action);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const state = store.getState();

    // Get activeUserInfo from the state
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const activeUserInfo = state.app.activeUserInfo;

    const EmptyGuid = '00000000-0000-0000-0000-000000000000';

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const tenatId:string = activeUserInfo?.activeTenantId ?? EmptyGuid;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (action.type === setConversations.type || action.type ===  updateTokenUsage.type || action.type === deleteConversation.type || action.type === editConversationTitle.type  || action.type === addConversation.type) {

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const conversationsData = state.conversations.conversations;

    // Convert conversationsData to a string
    let conversationsString = JSON.stringify(conversationsData);

    // Define the pattern to replace recursively
    const pattern = /"conversations":/g;

    // Replace the pattern recursively
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    conversationsString = replaceRecursive(conversationsString, pattern, '');


    const cacheKeychatId = Constants.cacheKeys.LOCAL_CACHE_CURRENT_CHATID(tenatId);

    //const cacheConversationId = Constants.cacheKeys.LOCAL_CACHE_CURRENT_CHATS(tenatId);
    //localStorage.setItem(cacheConversationId, conversationsString);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    localStorage.setItem(cacheKeychatId, state.conversations.selectedId);

  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  else if (action.type === setSelectedConversation.type) {
    
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const cacheConversationId = Constants.cacheKeys.LOCAL_CACHE_CURRENT_CHATID(tenatId);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    localStorage.setItem(cacheConversationId, String(state.conversations.selectedId));
  }

  return result;
};

export default localStorageMiddleware;